import { Header } from '@asgard/ui-library';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import * as SP from '../../HrAsAServicePage.styled';
import * as S from './WhatIs.styled';

export const WhatIs: React.FC = () => {
  const { t } = useI18n('hr-as-a-service');

  const features = [
    {
      position: 'A',
      title: t('hr-as-a-service.what-is.feature1.title'),
      desc: (
        <HtmlTrans
          ns="hr-as-a-service"
          i18nKey={'hr-as-a-service.what-is.feature1.desc'}
        />
      )
    },

    {
      position: 'B',
      title: t('hr-as-a-service.what-is.feature2.title'),
      desc: (
        <HtmlTrans
          ns="hr-as-a-service"
          i18nKey={'hr-as-a-service.what-is.feature2.desc'}
        />
      )
    },

    {
      position: 'C',
      title: t('hr-as-a-service.what-is.feature3.title'),
      desc: (
        <HtmlTrans
          ns="hr-as-a-service"
          i18nKey={'hr-as-a-service.what-is.feature3.desc'}
        />
      )
    }
  ];

  return (
    <S.Root>
      <SP.Container>
        <S.Intro>
          <Header as="h3" size="5xl" editorial>
            <HtmlTrans
              ns="hr-as-a-service"
              i18nKey={'hr-as-a-service.what-is.title'}
            />
          </Header>

          <Header as="h4" size="2xl">
            <HtmlTrans
              ns="hr-as-a-service"
              i18nKey={'hr-as-a-service.what-is.subtitle'}
            />
          </Header>

          <HtmlTrans
            ns="hr-as-a-service"
            i18nKey={'hr-as-a-service.what-is.desc'}
          />

          <Header as="h4" size="2xl">
            <HtmlTrans
              ns="hr-as-a-service"
              i18nKey={'hr-as-a-service.what-is.for-you'}
            />
          </Header>
        </S.Intro>

        <S.Features>
          {features.map(({ title, position, desc }) => (
            <S.Feature key={title}>
              <Header as="h4" size="2xl">
                {position}
              </Header>
              <Header as="h5" size="l">
                {title}
              </Header>
              {desc}
            </S.Feature>
          ))}
        </S.Features>
      </SP.Container>
    </S.Root>
  );
};
